var _g, _mask, _mask2, _mask3, _mask4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161.23,
    height: 161.26,
    fill: "none",
    viewBox: "0 0 161.23 161.26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.622 40.302c-22.234 0-40.32 18.087-40.32 40.32 0 22.233 18.086 40.32 40.32 40.32 22.233 0 40.32-18.087 40.32-40.32 0-22.234-18.087-40.32-40.32-40.32zm-4.0425 72.312c-15.368-1.917-27.426-14.706-28.158-30.423l28.158 23.627zm0-17.32-27.182-22.791c0.8712-3.3455 2.3-6.4819 4.1121-9.3395l23.035 19.341v12.79zm0-23.314-17.877-14.985c4.8091-4.4606 11.012-7.4925 17.877-8.3637zm8.0849-23.349c6.8652 0.8712 13.034 3.8682 17.878 8.3637l-17.878 14.985zm0 33.873 23.07-19.341c1.847 2.8228 3.241 5.994 4.112 9.3395l-27.182 22.791zm0 30.11v-6.796l28.158-23.627c-0.732 15.682-12.789 28.471-28.158 30.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.83 113.24c0.662 0.383 1.359 0.592 2.091 0.592 1.359 0 2.683-0.697 3.45-1.951 5.68-9.41 8.712-20.213 8.712-31.26 0-33.35-27.113-60.463-60.463-60.463-11.047 0-21.85 2.997-31.259 8.7122-1.9167 1.15-2.5091 3.6243-1.3591 5.5409 1.15 1.9167 3.6243 2.5092 5.5409 1.3591 8.1546-4.9485 17.529-7.5273 27.112-7.5273 28.89 0 52.413 23.523 52.413 52.413 0 9.5834-2.614 18.958-7.563 27.113-1.185 1.846-0.557 4.321 1.325 5.471z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.156 45.634c-1.8469-1.2546-4.3561-0.7667-5.6106 1.0803-6.7955 10.036-10.385 21.746-10.385 33.908 0 33.35 27.112 60.463 60.463 60.463 12.162 0 23.872-3.59 33.908-10.385 1.847-1.255 2.335-3.764 1.08-5.611-1.254-1.847-3.763-2.335-5.61-1.08-8.678 5.889-18.853 8.991-29.378 8.991-28.89 0-52.413-23.488-52.413-52.413 0-10.524 3.1016-20.7 8.991-29.378 1.2894-1.8122 0.8015-4.3213-1.0455-5.5758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.962 128.82c1.8122-1.324 2.1955-3.833 0.9061-5.646-21.049-28.994-17.912-68.477 7.4576-93.847 25.37-25.37 64.854-28.541 93.848-7.4577 1.812 1.3243 4.321 0.9061 5.645-0.906 1.325-1.8122 0.907-4.3213-0.906-5.6455-15.368-11.152-34.291-16.518-53.318-15.09-19.237 1.4288-37.323 9.7228-50.984 23.384-13.661 13.661-21.955 31.747-23.384 50.984-1.4288 19.027 3.9379 37.951 15.09 53.319 0.8015 1.08 2.0212 1.673 3.2758 1.673 0.8364 0 1.6727-0.244 2.3697-0.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.93 33.333c-1.324-1.8122-3.833-2.1955-5.646-0.9061-1.812 1.3243-2.195 3.8334-0.906 5.6455 21.049 28.994 17.913 68.478-7.457 93.848s-64.854 28.541-93.848 7.458c-1.8121-1.325-4.3213-0.906-5.6455 0.906-1.3243 1.812-0.9061 4.321 0.9061 5.645 13.73 9.967 30.353 15.334 47.325 15.334 1.9864 0 4.0076-0.07 5.994-0.209 19.237-1.429 37.323-9.723 50.984-23.384s21.955-31.747 23.383-50.984c1.394-19.062-3.972-38.02-15.089-53.353z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    x: 275,
    y: 41,
    width: 62,
    height: 55,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.68 95.668-25.36-51.66c-0.732-1.5421-2.389-2.54-4.218-2.5536h-2.195c-1.825 0.0151-3.486 1.013-4.215 2.5536l-25.355 51.66h11.789l4.962-10.462h27.772l5.027 10.462h11.793zm-40.575-18.959 9.772-20.622 9.904 20.622z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    x: 451,
    y: 42,
    width: 49,
    height: 54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m489.33 42.737-0.048 38.434c5e-3 1.0472-0.413 2.0536-1.162 2.7975s-1.767 1.1644-2.831 1.1689h-18.581c-1.065-0.0016-2.087-0.4209-2.838-1.1652s-1.17-1.7523-1.164-2.8012l-0.047-38.434h-10.669v39.727c0 7.3025 5.983 13.235 13.334 13.235h21.339c7.35 0 13.335-5.9327 13.335-13.235v-39.727h-10.668z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    x: 362,
    y: 42,
    width: 66,
    height: 54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m393 85.199h3.625c1.833 0 3.189-1.0454 4.221-2.5213l15.463-22.845v35.867h10.744l-0.016-47.674c0-2.921-2.406-5.2885-5.373-5.2885h-4.058c-1.386 0-2.686 0.801-3.411 1.8448l-19.383 28.057-19.392-28.057c-0.729-1.0454-2.021-1.8448-3.406-1.8448h-4.062c-2.969 0.0051-5.372 2.3721-5.369 5.2885l-0.019 47.674h10.744v-35.867l15.46 22.845c1.035 1.4759 2.391 2.5213 4.232 2.5213",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    x: 200,
    y: 42,
    width: 54,
    height: 54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m242.57 79.818-29.506-35.236c-0.864-1.0454-1.977-1.8448-3.338-1.8448h-3.973c-2.912 0.0085-5.267 2.376-5.259 5.2885l-0.018 47.674h10.523v-37.081l29.502 35.221c0.864 1.0608 1.983 1.8602 3.344 1.8602h3.972c2.9 0 5.26-2.3675 5.26-5.287l0.015-47.675h-10.522z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.9932f71ee366d0a1e67993cd9a9dd909.svg";
export { ForwardRef as ReactComponent };